/* eslint-disable react/no-unused-prop-types */
import { string } from 'prop-types';
import { t } from '@lingui/macro';

import Filter from '../../page-framework/filter/FilterDecorator';
import { filterPropTypes } from '../../page-framework/filter/FilterPropTypes';
import OptionFilter from '../option-filter/OptionFilter';
import getOptionFilterStateServiceFactory from '../option-filter/OptionFilterStateService';

export const filterId = 'DeviceType';
export const filterTitle = t`Network Device Type`;
export const options = [
    {
        name: t`Router`,
        value: 'router',
    },
    {
        name: t`Switch`,
        value: 'switch',
    },
    {
        name: t`Wireless Controller`,
        value: 'wirelesscontroller',
    },
    {
        name: t`Access Point`,
        value: 'accesspoint',
    },
    {
        name: t`Generic`,
        value: 'generic',
    },
    {
        name: t`Firewall`,
        value: 'firewall',
    },
    {
        name: t`Packet Processor`,
        value: 'packet-processor',
    },
];

function NetworkDeviceTypeFilter({ state, filterActions }) {
    return <OptionFilter options={options} state={state} filterActions={filterActions} />;
}

NetworkDeviceTypeFilter.propTypes = {
    id: filterPropTypes.id,
    title: filterPropTypes.title,
    filterActions: filterPropTypes.filterActions,
    state: string,
};

NetworkDeviceTypeFilter.defaultProps = {
    ...OptionFilter.defaultProps,
    id: filterId,
    title: filterTitle,
};

export default Filter({
    filterId,
    filterStateServiceFactory: getOptionFilterStateServiceFactory(filterTitle, options, 'deviceType'),
})(NetworkDeviceTypeFilter);
